import useSWRMutationForm, { useErrorToSnackbar } from 'common-form/useSWRMutationForm';
import usePrequalUpdate from '../../resources/prequal/usePrequalUpdate';
import { transform as transformSSN } from '../InputTIN';

const useForm = () => {
  const onSubmit = (form) => ({
    ...form,
    ssn: transformSSN(form.ssn),
  });

  return useSWRMutationForm({
    useMutation: usePrequalUpdate,
    onSubmit,
    errorSchema: { NATIONAL_ID_ALREADY_EXISTS: {} },
    useUnhandledError: useErrorToSnackbar,
  });
};

export default useForm;
